import http from 'hub-http/clients/apiClient';
import { RAW_ALL_APP_SETTINGS_FETCH_SUCCESS, RAW_ALL_APP_SETTINGS_FETCH_FAILURE, RAW_ALL_APP_SETTINGS_FETCH_LOADING } from '../../types/AppSettings';
import { FetchStatuses, isIdle } from '../../types/FetchStatus';
import { useEffect, useReducer } from 'react';
const APP_SETTINGS_TO_FETCH = ['crmRecordsPage', 'crmPageEditor'];
const INITIAL_STATE = {
  status: FetchStatuses.IDLE,
  data: null
};
const reducer = (state, action) => {
  switch (action.type) {
    case RAW_ALL_APP_SETTINGS_FETCH_LOADING:
      return {
        status: FetchStatuses.LOADING,
        data: null
      };
    case RAW_ALL_APP_SETTINGS_FETCH_SUCCESS:
      return {
        status: FetchStatuses.RESOLVED,
        data: action.data
      };
    case RAW_ALL_APP_SETTINGS_FETCH_FAILURE:
      return {
        status: FetchStatuses.REJECTED,
        data: null,
        error: action.error
      };
    default:
      return state;
  }
};
export const useFetchRawAllAppSettings = () => {
  const [rawAllAppSettingsState, dispatch] = useReducer(reducer, INITIAL_STATE);
  useEffect(() => {
    if (!isIdle(rawAllAppSettingsState)) return;
    dispatch({
      type: RAW_ALL_APP_SETTINGS_FETCH_LOADING
    });
    http.post('framework-builder/v1/read/metadata/type/all/batch', {
      data: APP_SETTINGS_TO_FETCH
    }).then(data => {
      dispatch({
        type: RAW_ALL_APP_SETTINGS_FETCH_SUCCESS,
        data
      });
    }).catch(error => {
      dispatch({
        type: RAW_ALL_APP_SETTINGS_FETCH_FAILURE,
        error
      });
    });
  }, [rawAllAppSettingsState]);
  return rawAllAppSettingsState;
};